interface Props {
  variant?: 'default' | 'success' | 'danger' | 'warning' | 'info' | 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'
  children: React.ReactNode
}

// TailAdmin Badge.tsx, "light" variant colors.
const styles: Record<NonNullable<Props['variant']>, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-success-50 text-success-600',
  danger:  'bg-error-50 text-error-600',
  warning: 'bg-warning-50 text-warning-600',
  info:    'bg-blue-light-50 text-blue-light-500',
  GET:     'bg-blue-light-50 text-blue-light-500',
  POST:    'bg-success-50 text-success-600',
  PUT:     'bg-warning-50 text-warning-600',
  DELETE:  'bg-error-50 text-error-600',
  PATCH:   'bg-brand-50 text-brand-500',
}

export function Badge({ variant = 'default', children }: Props) {
  return <span className={`badge ${styles[variant]}`}>{children}</span>
}
